import { updatesData, carouselData, indexData } from '@/mocks/home';

export function UpdatesSection() {
  return (
    <section id='updates' className='py-10 md:py-16 px-4 md:px-6 bg-background-50'>
      <div className='w-full max-w-5xl mx-auto'>
        <h2 className='font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-2 text-center'>
          最新动态
        </h2>
        <p className='text-sm text-foreground-500 text-center mb-6 md:mb-10'>
          综艺更新快讯 · 每日同步
        </p>
        <div className='relative pl-6 border-l-2 border-primary-200'>
          {updatesData.map((item, idx) => {
            const tagClass =
              item.tag === '新上线' ? 'bg-accent-100 text-accent-700' :
              item.tag === '热播中' ? 'bg-primary-100 text-primary-700' :
              item.tag === '预告' ? 'bg-secondary-100 text-secondary-700' :
              item.tag === '公告' ? 'bg-background-200 text-foreground-600' :
              'bg-background-100 text-foreground-600';
            return (
              <div key={idx} className='relative pb-6 md:pb-8 last:pb-0'>
                <span className='absolute -left-[25px] top-0 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-50'></span>
                <div className='flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-4'>
                  <span className='text-xs text-foreground-400 whitespace-nowrap font-label'>{item.date}</span>
                  <div className='flex-1'>
                    <div className='flex items-start gap-2'>
                      <span className={`inline-block px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${tagClass}`}>
                        {item.tag}
                      </span>
                      <h3 className='text-sm md:text-base text-foreground-800 font-medium leading-relaxed'>
                        {item.title}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export function CarouselSection() {
  return (
    <section id='carousel' className='py-10 md:py-16 px-4 md:px-6 bg-background-100'>
      <div className='w-full'>
        <h2 className='font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-2 text-center'>
          热门专题
        </h2>
        <p className='text-sm text-foreground-500 text-center mb-6 md:mb-10'>
          精选综艺专题 · 一网打尽
        </p>
        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5'>
          {carouselData.map((item) => (
            <div
              key={item.id}
              className='group bg-background-50 rounded-xl overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer'
            >
              <div className='relative w-full aspect-[16/10] overflow-hidden bg-background-200'>
                <img
                  src={item.image}
                  alt={item.title}
                  className='w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500'
                />
                <span className='absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap'>
                  {item.tag}
                </span>
              </div>
              <div className='p-4 md:p-5'>
                <h3 className='font-heading text-base md:text-lg font-bold text-foreground-900 mb-1'>
                  {item.title}
                </h3>
                <p className='text-xs md:text-sm text-primary-600 font-medium mb-2'>{item.subtitle}</p>
                <p className='text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2'>
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function IndexSection() {
  return (
    <section id='index' className='py-10 md:py-16 px-4 md:px-6 bg-background-50'>
      <div className='w-full max-w-6xl mx-auto'>
        <h2 className='font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-2 text-center'>
          综艺索引
        </h2>
        <p className='text-sm text-foreground-500 text-center mb-6 md:mb-10'>
          按品类浏览 · 快速找综艺
        </p>
        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4'>
          {indexData.map((item) => (
            <div
              key={item.title}
              className='flex items-start gap-3 md:gap-4 p-4 md:p-5 bg-background-100 rounded-xl hover:bg-background-200 transition-colors cursor-pointer group'
            >
              <div className='w-10 h-10 md:w-11 md:h-11 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-200 transition-colors'>
                <i className={`${item.icon} text-primary-600 text-lg md:text-xl`}></i>
              </div>
              <div className='flex-1 min-w-0'>
                <div className='flex items-center justify-between mb-1'>
                  <h3 className='font-heading text-sm md:text-base font-bold text-foreground-900'>{item.title}</h3>
                  <span className='text-xs text-foreground-400 whitespace-nowrap'>{item.count}</span>
                </div>
                <p className='text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-1'>
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}